import { useEffect, useState } from "react";

// One breakpoint for the whole site. The app styles everything with inline
// style objects, which CSS media queries can't override - so any layout that
// needs to change on phones asks this hook instead.
export const MOBILE_BREAKPOINT = 700;

export function useIsMobile(breakpoint = MOBILE_BREAKPOINT) {
    const query = "(max-width: " + breakpoint + "px)";
    const [isMobile, setIsMobile] = useState(() => window.matchMedia(query).matches);

    useEffect(() => {
        const mql = window.matchMedia(query);
        const onChange = (event) => setIsMobile(event.matches);
        setIsMobile(mql.matches);
        mql.addEventListener("change", onChange);
        return () => mql.removeEventListener("change", onChange);
    }, [query]);

    return isMobile;
}
